import { Select } from "@mantine/core";
import { IChecklistPopulated } from "@mctypes/checklist.types";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { selectCurrentProjectId } from "../../../global/globalSliceCommon";
import { useAppSelector } from "../../../hooks";
import { usePostProjectByProjectIdChecklistAllQuery } from "../../../../openapi";
import { selectActiveChecklist } from "./checklistSelectors";
import "./checklistapi.enhance";
import { ChecklistStatusEnum } from "./constants";

const EMPTY_CHECKLISTS: IChecklistPopulated[] = [];
type ChecklistPickerItem = Pick<IChecklistPopulated, "_id" | "id" | "name" | "status" | "templateType">;

const getChecklistPickerList = (
  checklist: IChecklistPopulated | null,
  checklists: ChecklistPickerItem[],
): ChecklistPickerItem[] => {
  if (checklist == null) {
    return EMPTY_CHECKLISTS;
  }

  return checklists.filter(
    (item) =>
      item.status !== ChecklistStatusEnum.REMOVED &&
      item.status !== ChecklistStatusEnum.DELIVERED &&
      item.templateType !== "MC",
  );
};

const ChecklistPicker: React.FC<{ checklist?: IChecklistPopulated | null }> = ({ checklist: checklistProp }) => {
  const { checklistId } = useParams<{ checklistId: string }>();
  const selectedChecklist = useAppSelector((state) => selectActiveChecklist(state, checklistId));
  const checklist = checklistProp ?? selectedChecklist;
  const projectId = useAppSelector(selectCurrentProjectId);

  const history = useHistory();

  const { data: checklists = EMPTY_CHECKLISTS } = usePostProjectByProjectIdChecklistAllQuery(
    {
      projectId: projectId ?? "",
      body: checklist?.isTemplate === true ? { isTemplate: true } : {},
    },
    { skip: projectId == null || checklist == null },
  );
  const list = getChecklistPickerList(checklist, checklists);

  const goToChecklist = (checklistId: string) => {
    if (projectId == null) return;
    history.push(`/project/${projectId}/checklist/instance/${checklistId}`);
  };

  const goToChecklistSelection = () => {
    if (projectId == null) return;
    history.push(`/project/${projectId}/checklist`);
  };

  const handleSelectChange = (checklistId: string | null) => {
    if (checklistId === "selection") {
      goToChecklistSelection();
    } else if (checklistId) {
      goToChecklist(checklistId);
    }
  };

  return (
    <>
      {list.length > 0 && (
        <Select
          w="lg"
          size="sm"
          value={checklist?._id || "selection"}
          onChange={handleSelectChange}
          placeholder={checklist?.name || "Velg sjekkliste"}
          data={[
            ...list.map((cl) => ({
              value: cl._id,
              label: cl.name,
            })),
            { value: "selection", label: "Gå til Utvalg" },
          ]}
          style={{ minWidth: "200px" }}
          searchable
        />
      )}
    </>
  );
};

export default ChecklistPicker;
